export default __webpack_public_path__ + "static/media/intro-apis-mob.f03045f0.png";